import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { CheckBoxModule } from 'app/shared/components/check-box/check-box.module';
import { PaginationModule } from 'app/shared/components/pagination/pagination.module';
import { ScrollViewModule } from 'app/shared/components/scroll-view/scroll-view.module';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { ResultsTableViewComponent } from './results-table-view.component';
import { PipesModule } from 'app/shared/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    MatTableModule,
    PaginationModule,
    ButtonModule,
    TooltipModule,
    ScrollViewModule,
    BlockModalDragModule,
    CheckBoxModule,
    PipesModule,
  ],
  declarations: [ResultsTableViewComponent],
  exports: [ResultsTableViewComponent],
})
export class ResultsTableViewModule {}
